import { tints } from '@manychat/manyui'

import { VIRTUAL_FLOW_ID } from 'common/builder/components/aiAssistantFlowViewer/hooks/useVirtualBuilder'
import { getActionNodeAction } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/getActionNodeAction'
import { getActionNodeNextStep } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/getActionNodeNextStep'
import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { FlowChartNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNodeHeaderBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  ActionConfig,
  DEFAULT_ICON_RENDER_SIZE,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartActionNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartActionNode'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { NodeType } from 'common/builder/constants/NodeType'
import { IActionGroupNode } from 'common/builder/nodes/nodeInterfaces'
import { isTargetAllowed } from 'common/builder/selectors/builder/nextStepSelectors'

export const ActionNodeGenericConverterRule: ConverterRule<
  IActionGroupNode,
  FlowChartActionNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: IActionGroupNode) => entity?.nodeType === NodeType.ACTION_GROUP,

  convert: (entity: IActionGroupNode, { state, builderId, flowId }) => {
    if (entity.flow !== flowId && flowId !== VIRTUAL_FLOW_ID) {
      return null
    }

    const hasNextStep = isTargetAllowed(state, builderId, entity.id)
    const nextStep = getActionNodeNextStep(entity)

    const node: FlowChartActionNode = {
      id: entity.id,
      type: FlowChartNodeType.ACTION,
      nodeType: NodeType.ACTION_GROUP,
      onboardingElementId: entity.onboardingElementId,
      data: {
        header: new FlowChartNodeHeaderBuilder(entity.caption)
          .withColor(ActionConfig.headerBackground)
          .withIcon(
            new FlowChartIconBuilder(ActionConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE)
              .withColor(ActionConfig?.iconColor || tints.neutral[0])
              .build(),
          )
          .build(),
        actions: entity.items.map((action) => getActionNodeAction(action, builderId, state)),
        nextStep: hasNextStep ? nextStep : null,
      },
    }

    return node
  },
}
